import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';
import { isDevEnv, isHomologEnv } from 'utils/env';

const history = createBrowserHistory();

// Disable console log on production and homolog
//  pending see why homolog returning production
// Change before Sentry, allowing Sentry to log console messages but not show on the console ouput.
if (!isDevEnv && !isHomologEnv) {
  window.console = {
    ...window.console,
    info: () => {},
    log: () => {},
    warn: () => {},
  };
}

Sentry.init({
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: process.env.REACT_APP_VERSION,
  integrations: [
    Sentry.captureConsoleIntegration({ levels: ['error'] }),
    Sentry.reactRouterV5BrowserTracingIntegration({ history }),
    Sentry.replayIntegration({
      maskAllText: false,
    }),
  ],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: process.env.REACT_APP_SENTRY_ENVIRONMENT === 'Dev' ? 0.4 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/.*\.lkp\.app\.br/, /^https:\/\/.*\.lkp\.dev\.br/],
  // debug: process.env.REACT_APP_SENTRY_ENVIRONMENT === 'Dev',
  replaysOnErrorSampleRate: process.env.REACT_APP_SENTRY_ENVIRONMENT === 'Dev' ? 1.0 : 0.4,
  replaysSessionSampleRate: process.env.REACT_APP_SENTRY_ENVIRONMENT === 'Dev' ? 1.0 : 0.3,
});
